import styled from 'styled-components';

import { CrossIcon } from '../../icons';
import { COOKIE_CONSENT_BANNER_ZINDEX } from '../cookie-consent-banner/CookieConsentBanner';

export const Container = styled.div``;

export const Background = styled.div`
	position: fixed;
	bottom: 0;
	right: 0;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: ${COOKIE_CONSENT_BANNER_ZINDEX + 1};
`;

export const Foreground = styled.div<{
	$background?: string;
	$detached: boolean;
	$fullHeight: boolean;
	$modalHeight: number;
	$showCloseButton: boolean;
	$size: string;
}>`
	display: flex;
	flex-direction: column;
	width: 80%;
	max-width: ${({ $size }) => $size};
	height: ${({ $fullHeight, $modalHeight }) => ($fullHeight ? `${$modalHeight}px;` : 'auto')};
	max-height: ${({ $modalHeight }) => `${$modalHeight}px`};
	background: ${({ $background, theme }) => $background ?? theme.colors.backgrounds.main.container};
	${({ theme }) => theme.border.radius.xlarge};
	padding: ${({ $showCloseButton, theme }) =>
		`${$showCloseButton ? 0 : theme.spacings.xxlarge} ${theme.spacings.large} ${theme.spacings.xlarge} ${
			theme.spacings.large
		}`};
	overflow: auto;
`;

export const Header = styled.div<{ $showCloseButton: boolean }>`
	display: flex;
	justify-content: flex-end;
	padding: ${({ $showCloseButton, theme }) =>
		`${$showCloseButton ? theme.spacings.xlarge : 0} 0 ${$showCloseButton ? theme.spacings.large : 0} 0`};
`;

export const SubHeader = styled.div`
	width: 100%;
	margin-bottom: ${({ theme }) => theme.spacings.large};
`;

export const Close = styled(CrossIcon)<{ $color?: string }>`
	color: ${({ $color, theme }) => $color ?? theme.colors.icons.main.unselected};
	cursor: pointer;
`;

export const Content = styled.div`
	flex-grow: 1;
	overflow-y: auto;
`;

export const Footer = styled.div`
	margin-top: ${({ theme }) => theme.spacings.large};
`;
